import Apricots from "./Apricots";

export default Apricots;